import { UsersPage, UserPage } from "./user";
import { RolesPage, RolePage } from "./role";
import { PermissionsPage, PermissionPage } from "./permission";
import { SuppliersPage, SupplierPage } from "./supplier";
import { TeamsPage, TeamPage } from "./team";
import { FlooringsPage, FlooringPage } from "./flooring";
import { EquipmentsPage, EquipmentPage } from "./equipment";
import { VariableGroupPage, VariableListPage } from "./variable";
import { GraphicsPage, GraphicPage } from "./graphic";
import { StandsPage, StandPage } from "./stand";
import { ExhibitionsPage, ExhibitionPage } from "./exhibition";
import { OrganizersPage, OrganizerPage } from "./organizer";
import { CommunicationsPage } from "./communication";

import Dashboard from "./dashboard/dashboard-page";
import Page404 from "./404/404-page";
import Page403 from "./403/403-page";

import "./pages.scss";

export const Pages = {
    Users: UsersPage,
    User: UserPage,
    Roles: RolesPage,
    Role: RolePage,
    Permissions: PermissionsPage,
    Permission: PermissionPage,
    Suppliers: SuppliersPage,
    Supplier: SupplierPage,
    Teams: TeamsPage,
    Team: TeamPage,
    Floorings: FlooringsPage,
    Flooring: FlooringPage,
    Equipments: EquipmentsPage,
    Equipment: EquipmentPage,
    VariableGroup: VariableGroupPage,
    VariableList: VariableListPage,
    Graphics: GraphicsPage,
    Graphic: GraphicPage,
    Stands: StandsPage,
    Stand: StandPage,
    Exhibitions: ExhibitionsPage,
    Exhibition: ExhibitionPage,
    Organizers: OrganizersPage,
    Organizer: OrganizerPage,
    Communications: CommunicationsPage,
    Dashboard,
    Page404,
    Page403,
};
